export default __webpack_public_path__ + "static/media/portada.5b8f3b80.jpg";